import { render, staticRenderFns } from "./exhibitor-configuration.vue?vue&type=template&id=2f725aa0&scoped=true&"
import script from "./exhibitor-configuration.vue?vue&type=script&lang=js&"
export * from "./exhibitor-configuration.vue?vue&type=script&lang=js&"
import style0 from "./exhibitor-configuration.vue?vue&type=style&index=0&id=2f725aa0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f725aa0",
  null
  
)

export default component.exports